import React from 'react';
import 'partial/OfferManager/modules/AutoRefinance/AutoRefinance.scss';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import SectionContainer from 'components/Containers/SectionContainer';
import PageContainer from 'components/Containers/PageContainer';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import { useConfig } from 'hook/config.hook';
import { Button } from 'components/form/Button';
import { goToAutoLoanRefinanceMarketplace } from 'helpers/autoOffer.helpers';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import { AUTO_REFINANCE } from 'types/morph.pagePosition.constants';
import { AUTO_LOAN_VERTICAL } from 'types/marketplaceTiles.constants';
import { autoRefinanceOfferHowIsCalculatedTooltip } from '../../../../helpers/offer.helpers';

function AutoRefinanceView({
  savingsAmount,
  currentLoanDetails,
  offers,
  userInfo,
  creditInfo,
  linkEventHandler,
  seenPixel,
  ...props
}) {
  const { config } = useConfig();
  const title = `Save money by refinancing your ${currentLoanDetails.name} auto loan`;
  let autoLoanSectionTooltip = '';
  if (config) {
    const overViewAutoLoanHowCalculated =
      config?.disclaimers?.autoLoans?.overviewAutoLoanHowIsThisCalculated;
    autoLoanSectionTooltip = autoRefinanceOfferHowIsCalculatedTooltip(
      overViewAutoLoanHowCalculated,
      currentLoanDetails,
    );
  }
  return (
    <>
      {seenPixel}
      <PageContainer className="autoRefinanceContainer">
        <SectionContainer className="padLR36 padTB24 m-padLR16 m-padTB20">
          <FlexContainer className="justify-between margB8 m-margB12 t-flex-column">
            <Label
              type="H3"
              typeHeader={'h3'}
              className="format50 margT8 m-margT0 m-margB16 t-format100 m-format100"
            >
              {title}
            </Label>
            <div className="savingsContainer text-center margR32 padR16 m-margr0">
              <div className="Overline fontGray300 margT12 margB16">
                SAVE UP TO
              </div>
              <div className="margB12 fontGreen300 text-36 lineHeight-0-44">
                ${savingsAmount}
              </div>
              <div className="Overline fontGray300">PER MONTH</div>
            </div>
          </FlexContainer>
          <div className="text-right margB10 m-text-left">
            <CSTooltip
              removeMarginsMobile
              isInline={true}
              placement={'bottom'}
              pagePosition={AUTO_REFINANCE}
              tooltipContent={autoLoanSectionTooltip}
              tooltipName="How is this calculated"
              overlayClassName="annualIncomeCSTooltip"
              vertical={AUTO_LOAN_VERTICAL}
            >
              <Label type="caption" className="pointer fontBlue100">
                How is this calculated?
              </Label>
            </CSTooltip>
          </div>

          <StaticOfferContainer
            offerMetadataList={offers}
            showComparison={true}
            currentLoanDetails={currentLoanDetails}
            termsPostfix={' mo.'}
            eventHandler={props.eventHandler}
            pagePosition={AUTO_REFINANCE}
            modulePosition={1}
          />
          <div className="text-center padT8 m-padT4">
            <Button
              mrphType="link"
              onClick={() =>
                goToAutoLoanRefinanceMarketplace(
                  currentLoanDetails,
                  userInfo,
                  creditInfo,
                  linkEventHandler,
                  props.dispatch,
                  props.history,
                )
              }
            >
              See more options
            </Button>
          </div>
        </SectionContainer>
        <Row />
      </PageContainer>
    </>
  );
}

export default AutoRefinanceView;
